<template>
  <div>
    <h1 class="title">Company Management</h1>
    <h2 class="subtitle is-5">
      From here you're able to add a new company or user and view all currently enabled users.
    </h2>

    <div class="box has-background-light">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Company Name</label>
            <input class="input" v-model="addCompanyName" type="text">
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Company ID</label>
            <input class="input" v-model="addCompanyId" type="text">
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">Add Discount list</label>
        <discountManagement v-on:fileID="addDiscountID" />
        <input type="hidden" class="input" v-model="discountListId" />
      </div>
      <div class="field">
        <a class="button" @click="addCompanyDetails">
          Add company
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import errorHandler from '@/errorHandler';
import discountManagement from '@/components/settings/discountManagement.vue';

export default {
  components: {
    discountManagement,
  },

  data() {
    return {
      addCompanyName: '',
      discountListId: '',
      addCompanyId: '',
    };
  },

  methods: {
    addDiscountID(value) {
      this.discountListId = value;
    },

    // Add / Manage Company Details
    addCompanyDetails() {
      fetch('/api/company', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: this.addCompanyName, discountListID: this.discountListId, number: this.addCompanyId }),
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.$awn.success(`Added company: ${response.name}`);
          // Update the company details
          this.fetchCompanyDetails();
        });
    },
  },
};
</script>
